import script from "./LayoutSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./LayoutSidebar.vue?vue&type=script&setup=true&lang=js"

import "./LayoutSidebar.vue?vue&type=style&index=0&id=10e0c080&lang=css"

const __exports__ = script;

export default __exports__